/** @format */

import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import { AiFillInfoCircle } from "react-icons/ai";

import { useSortableData } from "../../utils/sortableData";
import DataCount from "../../utils/dataCount";
import SkillModal from "./skillModal";

function AccordionBody({ data }) {
  let itemsPerPage = 5;
  const { t } = useTranslation();

  const [tableData, setTableData] = useState({
    currentItems: [],
    pageCount: 0,
    itemOffset: 0,
    modalOpen: false,
    skillInfo: []
  });
  const { items } = useSortableData(data);

  useEffect(() => {
    const endOffset = tableData.itemOffset + itemsPerPage;
    setTableData((prevState) => ({
      ...prevState,
      currentItems: items.slice(tableData.itemOffset, endOffset),
    }));
    setTableData((prevState) => ({
      ...prevState,
      pageCount: Math.ceil(items.length / itemsPerPage),
    }));
  }, [tableData.itemOffset, itemsPerPage, items]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setTableData((prevState) => ({ ...prevState, itemOffset: newOffset }));
  };

  const dataCheck = (val) => (val ? val : "-");

  return (
    <Accordion.Body>
      <div
        className="table-responsive"
        style={{ width: "100%", overflowX: "scroll" }}
      >
        <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
          <thead>
            <tr className="text-left">
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.id")}
              </th>
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.name")}
              </th>
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.email")}
              </th>
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.emiratesId")}
              </th>
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.mobileNumber")}
              </th>
              <th className="c-pointer">
                <span className="text-secondary"></span>
                {t("userManagement.cspInfo.staffSkills")}
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.currentItems?.map(
              ({ id, name, email, emiratesId, mobileNumber, skillInfo }) => (
                <tr key={id}>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      {id}
                    </span>
                  </td>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      {dataCheck(name)}
                    </span>
                  </td>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      {dataCheck(email)}
                    </span>
                  </td>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      {dataCheck(emiratesId)}
                    </span>
                  </td>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      {dataCheck(mobileNumber)}
                    </span>
                  </td>
                  <td>
                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                      <AiFillInfoCircle onClick={() => setTableData((prevState) => ({...prevState, modalOpen: true, skillInfo }))} />
                    </span>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
        {tableData.pageCount > 1 && (
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            previousLabel="<"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={tableData.pageCount}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        )}
        {data.length === 0 && (
          <p className="text-center mt-5 mb-5">
            {t("jobsManagement.noDataAvailable")}
          </p>
        )}
        {data.length ? (
          <DataCount itemOffset={tableData.itemOffset} items={items} />
        ) : null}
      </div>
      {tableData.modalOpen ? ( 
        <SkillModal
          t={t}
          showModal={tableData.modalOpen}
          data={tableData.skillInfo}
          handleCancel={() =>
            setTableData((prevState) => ({ ...prevState, modalOpen: false }))
          }
        />
      ) : null}
    </Accordion.Body>
  );
}

export default AccordionBody;
